<script>

import LazyBackgroundImage from "./LazyBackgroundImage.vue";

export default {
    data() {
        return {
            selectedCategory: null,
            categories: [],
        };
    },

    props: {
        postData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        articleTypes: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },

    computed: {
        articlesFiltered: function () {
            var self = this,
                articlesMutable = [];

            for (let i = 0; i < self.postData.length; i++) {
                var article = self.postData[i];

                if (self.selectedCategory) {
                    if (
                        !self.articleHasCategory(
                            article,
                            self.selectedCategory.slug
                        )
                    ) {
                        continue;
                    }
                }

                articlesMutable.push(article);
            }

            return articlesMutable;
        },
    },

    watch: {
        selectedCategory: function (newValue, oldValue) {
            var self = this;

            setTimeout(function () {
                window.dispatchEvent(new Event("resize"));
            }, 500);
        },
    },

    methods: {
        isTouchDevice() {
            try {
                document.createEvent("TouchEvent");
                return true;
            } catch (e) {
                return false;
            }
        },
        didSelectCategory: function (category) {
            this.selectedCategory = category;
        },
        reloadCategories: function () {
            var termsMutable = [];

            for (let i = 0; i < this.postData.length; i++) {
                var article = this.postData[i];
                if (article.categories.length) {
                    for (
                        let ii = 0;
                        ii < article.categories.length;
                        ii++
                    ) {
                        var category = article.categories[ii];
                        var existingCategory = termsMutable.find((item) => {
                            return item.slug == category.slug;
                        });

                        if (!existingCategory) {
                            termsMutable.push(category);
                        }
                    }
                }
            }

            this.categories = termsMutable;
        },
        isTouchDevice() {
            try {
                document.createEvent("TouchEvent");
                return true;
            } catch (e) {
                return false;
            }
        },
        didSelectTile(e) {
            var self = this;

            if (self.isTouchDevice()) {
                e.stopPropagation();
                e.preventDefault();
            }
        },
        didSelectFilter: function (termObject) {
            this.selectedArticleTypeSlug = termObject ? termObject.slug : null;
        },
        articleHasCategory: function (article, slug) {
            if (!article.categories || !article.categories.length) {
                return false;
            }

            for (let i = 0; i < article.categories.length; i++) {
                if (article.categories[i].slug === slug) {
                    return true;
                }
            }

            return false;
        },
    },

    components: {
        LazyBackgroundImage,
    },

    created() {},
    mounted() {
        this.reloadCategories();
    },
};
</script>

<style></style>

<template>
    <div class="articles">
        
        <div class="articles__filter">
             <h6 class="border-top">FILTER</h6>
            <ul>
                <li>
                <button
                    v-on:click.prevent="didSelectCategory(null)"
                    :class="{ selected: !selectedCategory }"
                >
                    All
                </button>
            </li>
            <li v-for="category in categories" :key="category.slug">
                <button
                    v-on:click.prevent="didSelectCategory(category)"
                    :class="{
                        selected:
                            selectedCategory &&
                            selectedCategory.slug === category.slug,
                    }"
                >
                    {{ category.title }}
                </button>
            </li>
            </ul>
        </div>
        
       
        <article class="article" v-for="article in articlesFiltered" :key="article.slug">
            <header class="article__header">
                <h4 class="category-title">{{ article.categories[0].title }}</h4>
                <div class="article__header__article-meta">
                    <time>{{ article.date }}</time>
                    <span>mins</span>
                </div>
            </header>
            <h2><a :href="article.url">{{ article.title }}</a></h2>
            
            {{ article.color}}

            <!-- <lazy-background-image
                :src="article.categories[0].slug"
             >
            ></lazy-background-image> -->

        </article>
      
       
    </div>
</template>
